import { IQuoteSetting, IQuoteTyreOffer } from '~/purchase/types';
import { IUserCustomer } from '~/common/types';
import { QuoteProductResult, QuoteTableHeader } from '~/purchase/components';

type Props = {
  items: Array<IQuoteTyreOffer>;
  showBuyingInfo: boolean;
  requestedQuantity: number;
  customer: IUserCustomer;
  quoteSetting: IQuoteSetting;
  onRefreshTyre: (ean: string, quantity: number) => void;
};

function QuoteLinesDisplay({
  items,
  showBuyingInfo,
  requestedQuantity,
  customer,
  quoteSetting,
  onRefreshTyre,
}: Props) {
  return (
    <>
      <QuoteTableHeader showBuyingInfo={showBuyingInfo} />
      {items.map((item) => (
        <QuoteProductResult
          key={item.tyre.ean}
          tyreOffer={item}
          defaultQuantity={requestedQuantity}
          customer={customer}
          showBfDiscount={quoteSetting.showBfDiscount}
          showBuyingInfo={showBuyingInfo}
          onRefreshTyre={onRefreshTyre}
          type='LINE'
        />
      ))}
    </>
  );
}

export default QuoteLinesDisplay;
